module.exports = __webpack_public_path__ + "images/emoji/hotsprings.257aa464c5e029675090.png";